<template>
	<div class="pagination">
		<div class="pagination_action" @click="onFirstPageClick">
			<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M10.2298 9.88215C10.1647 9.94724 10.1647 10.0528 10.2298 10.1179L15.4739 15.3619C15.7342 15.6223 15.7342 16.0444 15.4739 16.3047C15.2135 16.5651 14.7914 16.5651 14.5311 16.3047L9.287 11.0607C8.70121 10.4749 8.70121 9.52513 9.287 8.93934L14.5311 3.69526C14.7914 3.43491 15.2135 3.43491 15.4739 3.69526C15.7342 3.95561 15.7342 4.37772 15.4739 4.63807L10.2298 9.88215Z"
					fill="#F7F9FF"
				/>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M6.47981 9.88215C6.41472 9.94724 6.41472 10.0528 6.47981 10.1179L11.7239 15.3619C11.9842 15.6223 11.9842 16.0444 11.7239 16.3047C11.4635 16.5651 11.0414 16.5651 10.7811 16.3047L5.537 11.0607C4.95121 10.4749 4.95121 9.52513 5.537 8.93934L10.7811 3.69526C11.0414 3.43491 11.4635 3.43491 11.7239 3.69526C11.9842 3.95561 11.9842 4.37772 11.7239 4.63807L6.47981 9.88215Z"
					fill="#F7F9FF"
				/>
			</svg>
		</div>
		<div class="pagination_action" @click="onPrevPageClick">
			<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M8.14387 9.88215C8.07878 9.94724 8.07878 10.0528 8.14387 10.1179L13.3879 15.3619C13.6483 15.6223 13.6483 16.0444 13.3879 16.3047C13.1276 16.5651 12.7055 16.5651 12.4451 16.3047L7.20106 11.0607C6.61527 10.4749 6.61527 9.52513 7.20106 8.93934L12.4451 3.69526C12.7055 3.43491 13.1276 3.43491 13.3879 3.69526C13.6483 3.95561 13.6483 4.37772 13.3879 4.63807L8.14387 9.88215Z"
					fill="#F7F9FF"
				/>
			</svg>
		</div>

		<div class="pagination_num">
			<p
				v-for="i in Math.min(maxShow, Math.max(totalCount - prevPageCount, 0))"
				:key="i"
				:class="currentPage === prevPageCount + i && 'on'"
				@click="onPageClick(prevPageCount + i)"
			>
				{{ prevPageCount + i }}
			</p>
		</div>

		<div class="pagination_action" @click="onNextPageClick">
			<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M12.6882 10.1179C12.7533 10.0528 12.7533 9.94724 12.6882 9.88215L7.44409 4.63807C7.18374 4.37772 7.18374 3.95561 7.44409 3.69526C7.70443 3.43491 8.12654 3.43491 8.38689 3.69526L13.631 8.93934C14.2168 9.52513 14.2168 10.4749 13.631 11.0607L8.38689 16.3047C8.12654 16.5651 7.70443 16.5651 7.44408 16.3047C7.18374 16.0444 7.18374 15.6223 7.44408 15.3619L12.6882 10.1179Z"
					fill="#F7F9FF"
				/>
			</svg>
		</div>
		<div class="pagination_action" @click="onLastPageClick">
			<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M9.77019 10.1179C9.83528 10.0528 9.83528 9.94724 9.77019 9.88215L4.52612 4.63807C4.26577 4.37772 4.26577 3.95561 4.52612 3.69526C4.78647 3.43491 5.20858 3.43491 5.46893 3.69526L10.713 8.93934C11.2988 9.52513 11.2988 10.4749 10.713 11.0607L5.46892 16.3047C5.20858 16.5651 4.78647 16.5651 4.52612 16.3047C4.26577 16.0444 4.26577 15.6223 4.52612 15.3619L9.77019 10.1179Z"
					fill="#F7F9FF"
				/>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M13.5202 10.1179C13.5853 10.0528 13.5853 9.94724 13.5202 9.88215L8.27612 4.63807C8.01577 4.37772 8.01577 3.95561 8.27612 3.69526C8.53647 3.43491 8.95858 3.43491 9.21893 3.69526L14.463 8.93934C15.0488 9.52513 15.0488 10.4749 14.463 11.0607L9.21892 16.3047C8.95858 16.5651 8.53647 16.5651 8.27612 16.3047C8.01577 16.0444 8.01577 15.6223 8.27612 15.3619L13.5202 10.1179Z"
					fill="#F7F9FF"
				/>
			</svg>
		</div>
	</div>
</template>

<script setup lang="ts">
import { computed, onMounted, onUnmounted, ref } from 'vue';

const props = defineProps<{
	currentPage: number; //	현재 페이지
	totalCount: number; //	총 페이지 수
}>();
const emit = defineEmits(['setPage']);

const maxShow = ref(window.innerWidth > 600 ? 10 : 5); //	한번에 보여줄 최대 페이지 범위

// 이전 범위의 페이지 수 (maxShow가 10일경우 현재 페이지가 1~10 이면 0, 11~20이면 10 반환)
const prevPageCount = computed(() => {
	return Math.max(Math.floor((props.currentPage - 1) / maxShow.value) * maxShow.value, 0);
});

const resizeHandler = () => {
	maxShow.value = window.innerWidth > 600 ? 10 : 5;
};
onMounted(() => {
	window.addEventListener('resize', resizeHandler);
});
onUnmounted(() => {
	window.removeEventListener('resize', resizeHandler);
});

const onFirstPageClick = () => {
	if (props.currentPage > 1) {
		emit('setPage', 1);
	}
};
const onPrevPageClick = () => {
	if (props.currentPage > 1) {
		emit('setPage', props.currentPage - 1);
	}
};
const onNextPageClick = () => {
	if (props.currentPage < props.totalCount) {
		emit('setPage', props.currentPage + 1);
	}
};
const onLastPageClick = () => {
	if (props.currentPage < props.totalCount) {
		emit('setPage', props.totalCount);
	}
};
const onPageClick = (page: number) => {
	emit('setPage', page);
};
</script>

<style scoped lang="scss">
.pagination {
	display: flex;
	align-items: center;
	justify-content: center;
	margin-top: var(--space-x-small);
	.pagination_num {
		display: flex;
		gap: var(--space-x-small);
	}
	.pagination_num p {
		flex-shrink: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 2.8rem;
		height: 2.8rem;
		/* border:1px solid var(--color-border-light); */
		// border-radius: var(--border-radius-full);
		font-weight: var(--font-w-medium);
		font-size: var(--font-s-mid);
		line-height: 1.79rem;
		color: #f7f9ff;
		cursor: pointer;
		transition-duration: 0.2s;
		&.on {
			color: var(--color-primary);
		}
	}
	.pagination_action {
		flex-shrink: 0;
		display: flex;
		align-content: center;
		justify-content: center;
		align-items: center;
		width: 3.6rem;
		height: 3.6rem;
		padding: 0.4rem;
		box-sizing: border-box;
		cursor: pointer;
		svg {
			width: 70%;
			// height: 70%;
		}
	}
}
</style>
